import { isSensitiveHeader } from './sensitive-headers';

export function maskHeaderValue(name: string, value: string): string {
  if (isSensitiveHeader(name)) {
    return '••••••••';
  }
  return value;
}
